import { Suspense } from 'react';
import { Navigate, Outlet, ScrollRestoration } from 'react-router-dom';
import RestrictedRoute from './RestrictedRoute';
import Loader from '@/components/Loader';
import { SelectCafeteria } from '@/modules/auth/pages/SelectCafeteria';
import Error from '@/modules/ErrorBoundaryPage';
import { lazyImport } from '@/utils/lazyImport';

const { Home } = lazyImport(async () => await import('@/modules/home'), 'Home');
const { MenuRoutes } = lazyImport(async () => await import('@/modules/menu'), 'MenuRoutes');
const { CartRoutes } = lazyImport(async () => await import('@/modules/cart'), 'CartRoutes');
const { AccountRoutes } = lazyImport(
  async () => await import('@/modules/account'),
  'AccountRoutes'
);
const { PaymentRoutes } = lazyImport(
  async () => await import('@/modules/payments'),
  'PaymentRoutes'
);
const { BookmarkRoutes } = lazyImport(
  async () => await import('@/modules/bookmarks'),
  'BookmarkRoutes'
);
const { AddressBookRoutes } = lazyImport(
  async () => await import('@/modules/addressbook'),
  'AddressBookRoutes'
);

const { GlobalSearchRoutes } = lazyImport(
  async () => await import('@/modules/global-search'),
  'GlobalSearchRoutes'
);

const { HelpRoutes } = lazyImport(async () => await import('@/modules/help'), 'HelpRoutes');
const { OrderRoutes } = lazyImport(async () => await import('@/modules/orders'), 'OrderRoutes');

const { OpenOrderDetails } = lazyImport(
  async () => await import('@/modules/common/OpenOrderDetails'),
  'OpenOrderDetails'
);

const App = () => (
  <RestrictedRoute>
    <Suspense fallback={<Loader />}>
      <Outlet />
      <ScrollRestoration />
    </Suspense>
  </RestrictedRoute>
);

export const protectedRoutes = [
  {
    path: '/',
    element: <App />,
    errorElement: <Error />,
    children: [
      {
        index: true,
        errorElement: <Error />,
        element: <Home />,
      },
      {
        path: 'search',
        element: <GlobalSearchRoutes />,
      },
      {
        path: 'select-cafeteria',
        errorElement: <Error />,
        element: <SelectCafeteria />,
      },
      {
        path: 'menu/:id',
        element: <MenuRoutes />,
      },
      {
        path: 'help/*',
        element: <HelpRoutes />,
      },
      {
        path: 'cart/*',
        element: <CartRoutes />,
      },
      {
        path: 'order/*',
        element: <OrderRoutes />,
      },
      {
        path: 'account/*',
        element: <AccountRoutes />,
      },
      {
        path: 'payments/*',
        element: <PaymentRoutes />,
      },
      {
        path: 'bookmarks/*',
        element: <BookmarkRoutes />,
      },
      {
        path: 'address-book/*',
        element: <AddressBookRoutes />,
      },
      {
        path: 'status/*',
        element: <Home />,
      },
      {
        path: 'cafe/*',
        element: <Home />,
      },
      { path: 'track-order/:id', element: <OpenOrderDetails /> },
      { path: '*', element: <Navigate to="/" /> },
    ],
  },
];
